import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDropdownData } from "../../useSeo";
import emailjs from "emailjs-com";
import CustomeHelmet from "pages/components/CustomeHelmet";
const Certificate = () => {
  const config = useDropdownData();
  const [dropdownData, setDropdownData] = useState(null);

  const [sendRequest, setSendRequest] = useState(false);
  const navigate = useNavigate();
  const validateSchema = Yup.object().shape({
    name: Yup.string().min(3, "Min Length (3)").required("Required"),
    procoorUsername: Yup.string().min(3, "Min Length (3)").required("Required"),
    personalEmail: Yup.string()
      .email("Invalid email format")
      .required("Required"),
    companyName: Yup.string().min(3, "Min Length (3)").required("Required"),
    position: Yup.string().min(3, "Min Length (3)").required("Required"),
    companyType: Yup.string().required("Required"),
    accountName: Yup.string().required("Required"),
    module: Yup.string().required("Required"),
    experience: Yup.string().required("Required"),
    section: Yup.string().required("Required"),
  });
  useEffect(() => {
    if (config) {
      setDropdownData(config);
    }
  }, [config]);
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    handleBlur,
    touched,
    resetForm,
  } = useFormik({
    initialValues: {
      name: "",
      procoorUsername: "",
      personalEmail: "",
      companyName: "",
      position: "",
      companyType: "",
      accountName: "",
      module: "",
      experience: "",
      section: "",
    },
    validationSchema: validateSchema,
    onSubmit: (values, actions) => {
      handleSubmits(values);
      setSendRequest(true);
      actions.setSubmitting(false);
    },
  });
  const handleSubmits = async (e) => {
    try {
      var raw = {
        name: values.name,
        companyName: values.companyName,
        position: values.position,
        personalEmail: values.personalEmail,
        companyType: values.companyType,
        accountName: values.accountName,
        procoorUsername: values.procoorUsername,
        module: values.module,
        experience: values.experience,
        section: values.section,
      };

      const res = await fetch("https://procoor.com/api/employees", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(raw),
      });

      await res.json();

      await emailjs.send(
        "service_cwy66lo", // Replace with your EmailJS service ID
        "template_oxz1pbm", // Replace with your EmailJS template ID
        raw,
        "hSovQK5LEaElSfCER" // Public key
      );
      navigate("/ThankPageContact");
      resetForm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <CustomeHelmet pageName="Certificate" />
      <main>
        <section
          className="contact contact_us_md  app-section Certificate"
          data-theme="dark"
        >
          <div className="container">
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className="col-lg-10"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {/* <ProcoorLogo /> */}
                <div className="contact__text" style={{ marginTop: "150px" }}>
                  <h3 className="title" style={{ color: "#37cc3a" }}>
                    Enter Your Information
                  </h3>
                  <p className="desc">
                    Thanks for your interest in Procoor certification. We will
                    receive your request and a representative will contact you.
                  </p>
                </div>
                <form
                  className="proForm row needs-validation"
                  onSubmit={handleSubmit}
                >
                  <div className="col-lg-6">
                    <div className="linebylineInput has-validation">
                      <label className="control-label" htmlFor="firstname">
                        Name*
                      </label>
                      {errors.name && touched.name ? (
                        <span className="TextError required control-label">
                          {errors.name}
                        </span>
                      ) : null}
                      <div className="inputDev ui input">
                        <input
                          type="text"
                          className={
                            "form-control large " +
                            (errors.name && touched.name ? " input_error" : "")
                          }
                          id="firstname"
                          name="name"
                          placeholder="Full Name"
                          required
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="linebylineInput has-validation">
                      <label
                        className="control-label"
                        htmlFor="procoorUsername"
                      >
                        Procoor Username
                      </label>
                      {errors.procoorUsername && touched.procoorUsername ? (
                        <span className="TextError required control-label">
                          {errors.procoorUsername}
                        </span>
                      ) : null}
                      <div className="inputDev ui input">
                        <input
                          type="text"
                          className={
                            "form-control large " +
                            (errors.procoorUsername && touched.procoorUsername
                              ? " input_error"
                              : "")
                          }
                          id="firstname"
                          name="procoorUsername"
                          placeholder="Username"
                          required
                          value={values.procoorUsername}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="linebylineInput has-validation">
                      <label className="control-label" htmlFor="personalEmail">
                        Personal Email*
                      </label>
                      {errors.personalEmail && touched.personalEmail ? (
                        <span className="TextError required control-label">
                          {errors.personalEmail}
                        </span>
                      ) : null}

                      <div className="inputDev ui input">
                        <input
                          type="email"
                          className={
                            "form-control large " +
                            (errors.personalEmail && touched.personalEmail
                              ? " input_error"
                              : "")
                          }
                          id="personalEmail"
                          name="personalEmail"
                          placeholder="example@acme.inc"
                          value={values.personalEmail}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="linebylineInput ">
                      <label className="control-label" htmlFor="company">
                        Company Name*
                      </label>
                      {errors.companyName && touched.companyName ? (
                        <span className="TextError required control-label">
                          {errors.companyName}
                        </span>
                      ) : null}
                      <div className="inputDev ui input">
                        <input
                          type="text"
                          className={
                            "form-control large " +
                            (errors.companyName && touched.companyName
                              ? " input_error"
                              : "")
                          }
                          id="company"
                          name="companyName"
                          required
                          placeholder="ACME Inc."
                          value={values.companyName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="linebylineInput has-validation">
                      <label className="control-label" htmlFor="position">
                        position*
                      </label>
                      {errors.position && touched.position ? (
                        <span className="TextError required control-label">
                          {errors.position}
                        </span>
                      ) : null}
                      <div className="inputDev ui input">
                        <input
                          type="text"
                          className={
                            "form-control large " +
                            (errors.position && touched.position
                              ? " input_error"
                              : "")
                          }
                          id="position"
                          name="position"
                          placeholder="position"
                          required
                          value={values.position}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="linebylineInput ">
                      <label className="control-label">Company type*</label>
                      {errors.companyType && touched.companyType ? (
                        <span className="TextError required control-label">
                          {errors.companyType}
                        </span>
                      ) : null}
                      <select
                        className={
                          "form-select " +
                          (errors.companyType && touched.companyType
                            ? " input_error"
                            : "")
                        }
                        value={values.companyType}
                        name="companyType"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option value="null">Please select one</option>
                        {dropdownData?.Companytype?.map((option) => (
                          <option value={option.title} key={option.id}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="linebylineInput ">
                      <label className="control-label">Account name*</label>
                      {errors.accountName && touched.accountName ? (
                        <span className="TextError required control-label">
                          {errors.accountName}
                        </span>
                      ) : null}
                      <select
                        className={
                          "form-select " +
                          (errors.accountName && touched.accountName
                            ? " input_error"
                            : "")
                        }
                        value={values.accountName}
                        name="accountName"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option value="null">Please select one</option>
                        {dropdownData?.accountName?.map((option) => (
                          <option value={option.title} key={option.id}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="linebylineInput ">
                      <label className="control-label">module*</label>
                      {errors.module && touched.module ? (
                        <span className="TextError required control-label">
                          {errors.module}
                        </span>
                      ) : null}
                      <select
                        className={
                          "form-select " +
                          (errors.module && touched.module
                            ? " input_error"
                            : "")
                        }
                        value={values.module}
                        name="module"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option value="null">Please select one</option>
                        {dropdownData?.module?.map((option) => (
                          <option value={option.title} key={option.id}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="linebylineInput ">
                      <label className="control-label">Section*</label>
                      {errors.section && touched.section ? (
                        <span className="TextError required control-label">
                          {errors.section}
                        </span>
                      ) : null}
                      <select
                        className={
                          "form-select " +
                          (errors.section && touched.section
                            ? " input_error"
                            : "")
                        }
                        value={values.section}
                        name="section"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option value="null">Please select one</option>
                        {dropdownData?.section?.map((option) => (
                          <option value={option.title} key={option.id}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="linebylineInput ">
                      <label className="control-label">Experience*</label>
                      {errors.experience && touched.experience ? (
                        <span className="TextError required control-label">
                          {errors.experience}
                        </span>
                      ) : null}
                      <select
                        className={
                          "form-select " +
                          (errors.experience && touched.experience
                            ? " input_error"
                            : "")
                        }
                        value={values.experience}
                        name="experience"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option value="null">Please select one</option>
                        {dropdownData?.experience?.map((option) => (
                          <option value={option.title} key={option.id}>
                            {option.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-12">
                    {sendRequest === false ? (
                      <button
                        type="submit"
                        value="Submit"
                        className={
                          "primaryBtn-1 largeBtn  icon-r btn " +
                          (!values.name ||
                          errors.name ||
                          errors.procoorUsername ||
                          !values.procoorUsername ||
                          errors.companyName ||
                          !values.companyName ||
                          errors.section ||
                          !values.section ||
                          errors.experience ||
                          !values.experience ||
                          errors.module ||
                          !values.module ||
                          errors.accountName ||
                          !values.accountName ||
                          errors.position ||
                          !values.position ||
                          errors.personalEmail ||
                          !values.personalEmail ||
                          errors.companyType ||
                          !values.companyType
                            ? "disabled"
                            : "")
                        }
                      >
                        <span>Done</span>
                        <img
                          src="assets/images/icons/correctWhiteArrow.svg"
                          className="arrow icon"
                          alt="arrow"
                        />
                      </button>
                    ) : (
                      <div className={"primaryBtn-1 largeBtn btn "}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 100 100"
                          preserveAspectRatio="xMidYMid"
                          className="lds-ellipsis"
                          style={{ background: "none" }}
                        >
                          <circle cx={84} cy={50} r={0} fill="#fff">
                            <animate
                              attributeName="r"
                              values="10;0;0;0;0"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="0s"
                            />
                            <animate
                              attributeName="cx"
                              values="84;84;84;84;84"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="0s"
                            />
                          </circle>
                          <circle cx={84} cy={50} r="3.53777" fill="#fff">
                            <animate
                              attributeName="r"
                              values="0;10;10;10;0"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="-0.85s"
                            />
                            <animate
                              attributeName="cx"
                              values="16;16;50;84;84"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="-0.85s"
                            />
                          </circle>
                          <circle cx="71.9716" cy={50} r={10} fill="#fff">
                            <animate
                              attributeName="r"
                              values="0;10;10;10;0"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="-0.425s"
                            />
                            <animate
                              attributeName="cx"
                              values="16;16;50;84;84"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="-0.425s"
                            />
                          </circle>
                          <circle cx="37.9716" cy={50} r={10} fill="#fff">
                            <animate
                              attributeName="r"
                              values="0;10;10;10;0"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="0s"
                            />
                            <animate
                              attributeName="cx"
                              values="16;16;50;84;84"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="0s"
                            />
                          </circle>
                          <circle cx={16} cy={50} r="6.46224" fill="#fff">
                            <animate
                              attributeName="r"
                              values="0;0;10;10;10"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="0s"
                            />
                            <animate
                              attributeName="cx"
                              values="16;16;16;50;84"
                              keyTimes="0;0.25;0.5;0.75;1"
                              keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                              calcMode="spline"
                              dur="1.7s"
                              repeatCount="indefinite"
                              begin="0s"
                            />
                          </circle>
                        </svg>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Certificate;
